(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MusicSheetIbqDeleteController',MusicSheetIbqDeleteController);

    MusicSheetIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'MusicSheet'];

    function MusicSheetIbqDeleteController($uibModalInstance, entity, MusicSheet) {
        var vm = this;

        vm.musicSheet = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MusicSheet.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
